import React from 'react';
import loadable from '@loadable/component';
import EditorialContentPageQuery from './query.graphql';
import Loader from 'src/components/loader';

const EditorialContent = loadable(
  () => import(/* webpackChunkName: "article" */ './editorial-content'),
  {
    fallback: <Loader />,
  }
);

EditorialContent.graphQL = EditorialContentPageQuery;

EditorialContent.variables = vars => {
  // Prismic preview feature sends this parameter
  // then we send that along to the Prismic API integration
  // as the `ref` option. This lets us preview unpublished
  // articles.
  if (vars.token) {
    return {
      id: vars.documentId,
      ref: vars.token,
    };
  }

  return vars;
};

export default EditorialContent;
